"use client"

import { X, MoreHorizontal} from "lucide-react"
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuItem,
  SidebarMenuAction,
  SidebarMenuButton,
  SidebarMenuSub,
  SidebarMenuSubButton,
} from "@/components/ui/sidebar"

export type ReportItem = {
  task_id: string
  player_id: string
  player_name: string
}

interface Props {
  items: ReportItem[]
  label?: string
  onSelect?: (task_id: string) => void
  onRemove?: (task_id: string) => void
}

export function NavReports({
  items,
  label = "Openstaande rapporten",
  onSelect,
  onRemove,
}: Props) {
  const hasRealItems = items.some(i => i.task_id !== "placeholder")

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{label}</SidebarGroupLabel>
      <SidebarMenuSub>
        {items.map(item => {
          const isPlaceholder = item.task_id === "placeholder"
          return (
            <SidebarMenuItem key={item.task_id}>
              <SidebarMenuSubButton
                data-disabled={isPlaceholder}
                onClick={() => {
                  if (!isPlaceholder) onSelect?.(item.task_id)
                }}
              >
                <span className="truncate cursor-pointer">{item.player_name}</span>
              </SidebarMenuSubButton>
              {!isPlaceholder && hasRealItems && onRemove && (
                <SidebarMenuAction
                  onClick={(e) => {
                    e.stopPropagation()
                    onRemove(item.task_id)
                  }}
                  title="Verwijder"
                >
                  <X className="h-3.5 w-3.5" />
                </SidebarMenuAction>
              )}
            </SidebarMenuItem>
          )
        })}
      </SidebarMenuSub>
    </SidebarGroup>
  )
}